<script lang="ts">
  import FeatherIcon from "svelte-feather-icon";
  import Link from "svelte-link";
  import { href } from "../../utils/Constant/Constant";
  const fsToggle = () => {
  if (
          (document.fullScreenElement && document.fullScreenElement !== null) ||
          (!document.mozFullScreen && !document.webkitIsFullScreen)
        ) {
          if (document.documentElement.requestFullScreen) {
            document.documentElement.requestFullScreen();
          } else if (document.documentElement.mozRequestFullScreen) {
            document.documentElement.mozRequestFullScreen();
          } else if (document.documentElement.webkitRequestFullScreen) {
            document.documentElement.webkitRequestFullScreen(
              Element.ALLOW_KEYBOARD_INPUT
            );
          }
        } else {
          if (document.cancelFullScreen) {
            document.cancelFullScreen();
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
          }
        }
}
</script>

<li>
  <Link class="text-dark" href={href} on:click={fsToggle}>
    <FeatherIcon icon="maximize" />
  </Link>
</li>
